<app-corretor-bio *ngIf="codigoCaptador > 0" [codigo]="codigoCaptador"></app-corretor-bio>
<div class="div-init">
  <!-- <a a (click)="acessaHome()">
    <div class="circle-icon">
      <svg style="margin-left:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
        fill="#c70000" stroke="#c70000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
        <path fill-rule="evenodd"
          d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
          clip-rule="evenodd" />
      </svg>
    </div>
  </a> -->
  <p style="margin-bottom: 0!important; width: 50%;">
    {{ quantidade2 }} {{ quantidade2 === 1 ? 'imóvel' : 'imóveis' }} encontrado{{ quantidade2 === 1 ? '' : 's' }}
    <span *ngIf="buscaAvancadaFilter.contrato === 'Locação'">para alugar</span>
    <span *ngIf="buscaAvancadaFilter.contrato ==='Compra'">para vender {{codigoCaptador > 0 ? 'agenciados por esse
      corretor(a)': ''}}</span>
    <!-- <span *ngIf="selectedCidadesDisponiveis != null"> em {{ selectedCidadesDisponiveis }}, RS.</span> -->
  </p>

  <div class="div-direita-inicial">
    <div style="display: block;" *ngIf="!hideOnProduciton">
      <button type="button" class="btn-filtro-mobile" (click)="toggleOverlay()" *ngIf="!isOverlayOpen && mobile">
        <span>Ver mapa</span>
      </button>
      <button type="button" class="btn-filtro-mobile" (click)="toggleOverlay()" *ngIf="isOverlayOpen && mobile">
        <span>Fechar mapa</span>
      </button>
      <div class="div-ordenador-filtro">
        <div class="select-ordenador-filtro">
          <div class="select-filtro">
            <select [(ngModel)]="selectedOrdenacao" (change)="handleOrdenacao(selectedOrdenacao)"
              style="width: 100% !important; color: #666666 !important; border: none; font-size: 13px; padding-right: 15px;">
              <option value=''>Ordenar por</option>
              <option *ngFor="let opcao of opcoesOrdenacao" [value]="opcao.lista">
                {{ opcao.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>

<div class="div-init-filtro">
  <div>
    <button type="button" class="btn-filtro" (click)="toggleFilterOverlay()">
      <i class="fa-solid fa-filter" style="margin-right: 10px;"></i> Filtros
    </button>
  </div>

  <div class="div-mobile">
    <div class="div-ordenador-filtro-mobile">
      <div class="select-ordenador-filtro">
        <div class="select-filtro">
          <select [(ngModel)]="selectedOrdenacao" (change)="handleOrdenacao(selectedOrdenacao)"
            style="width:95%!important; color: #666666!important; border: none;">
            <option value=''>Ordenar por</option>
            <option *ngFor="let opcao of opcoesOrdenacao" [value]="opcao.lista">
              {{ opcao.nome }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="div-campo-filtro" *ngIf="!this.mobile">
    <div class="mat-select-custom">
      <div class="select-wrapper">
        <div class="autocomplete-input" (click)="toggleDropdownBairro($event)">
          <div class="scroll-container">
            <!-- 🔹 Exibir bairros selecionados dentro do input -->
            <!-- 🔹 Exibir bairros selecionados dentro do input -->
            <div class="selected-items">
              <span *ngFor="let nome of selectedBairrosNomes" class="tag">
                {{ nome }} <i (click)="removeBairro(nome)" class="fa fa-times remove-tag"></i>
              </span>

              <!-- 🔹 Input para busca e seleção -->
              <input type="text" [(ngModel)]="searchTextBairro" (input)="filterOptionsBairro()"
                (keydown.enter)="addBairroFromInput()" (keydown.backspace)="removeLastBairro()"
                placeholder="Busque por Bairro..." class="autocomplete-input" (focus)="dropdownOpenBairro = true"
                (click)="keepDropdownOpen($event)" />
            </div>
          </div>
        </div>

        <!-- 🔹 Dropdown de sugestões -->
        <div class="dropdown-options" *ngIf="dropdownOpenBairro">
          <label *ngFor="let bairro of filteredBairros" class="option">
            <input type="checkbox" class="option-checkbox" (change)="toggleSelectionBairro(bairro)"
              [checked]="isBairroSelected(bairro.nome)" />
            <span class="custom-checkbox"></span>
            {{ bairro.nome }}
          </label>

          <div class="no-results" *ngIf="filteredBairros.length === 0">
            Nenhum bairro encontrado
          </div>
        </div>


      </div>
    </div>

    <div class="mat-select-custom">
      <div class="select-wrapper">
        <!-- 🔹 Campo de entrada e exibição -->
        <div class="autocomplete-input" (click)="toggleDropdownTip($event)">
          <div class="scroll-container" style="padding: 5px 0;">
            <span *ngIf="selectedTiposNomes.length > 0; else placeholder">
              {{ selectedTiposNomes.join(', ') }}
            </span>
          </div>
          <ng-template #placeholder>Busque por categoria</ng-template>
        </div>

        <!-- 🔹 Dropdown de opções -->
        <div class="dropdown-options" *ngIf="dropdownOpenTip">
          <label *ngFor="let subtipo of subTipos;let i = index;" class="option">
            <input type="checkbox" class="option-checkbox" (change)="toggleSelectionTip(i)"
              [checked]="subtipo.checked" />
            <span class="custom-checkbox"></span>

            {{ subtipo.name }}
          </label>

          <div class="no-results" *ngIf="subTipos.length === 0">
            Nenhuma categoria encontrada
          </div>
        </div>
      </div>
    </div>


    <div class="select-campo-filtro">
      <div class="select-filtro">
        <div style="border: none; background-color: transparent;">
          <div class="select-wrapper">
            <div class="autocomplete-input" (click)="toggleDropdownValores($event)">
              <div class="scroll-container">
                <i class="fa-solid fa-money-bill" style="color:rgba(197, 197, 197, 0.884);"></i>
                <p>
                  <ng-container *ngIf="temValor">
                    {{ valorMinimo | currency: 'BRL' }} + '...'
                  </ng-container>
                  Valor
                </p>
              </div>
            </div>
            <!-- 🔹 Dropdown de opções -->
            <div class="dropdown-options-principal" *ngIf="dropdownOpenValores">
              <div class="div-campo-filtro-adicional">
                <input class="select-campo-filtro-adicional" type="text" mask="separator.2" prefix="R$ "
                  thousandSeparator="." decimalMarker="," [(ngModel)]="valorMinimo" placeholder="De" />
                <input class="select-campo-filtro-adicional" type="text" mask="separator.2" prefix="R$ "
                  thousandSeparator="." decimalMarker="," [(ngModel)]="valorMaximo" placeholder="Até" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <div class="select-campo-filtro" *ngIf="selectedFinalidade">
      <i class="fa-solid fa-money-bill" style="color:rgba(197, 197, 197, 0.884);"></i>
      <select [(ngModel)]="selectedValor">
        <option value=null>Valor</option>
        <option *ngFor="let num of opcoesValor" [value]="num.valor">
          {{ num.label }}
        </option>
      </select>
    </div> -->
    <div class="select-campo-filtro">
      <div class="select-filtro">
        <div style="border: none; background-color: transparent;">
          <div class="select-wrapper">
            <div class="autocomplete-input" (click)="toggleDropdownDormitorios($event)">
              <div class="scroll-container">
                <i class="fa-solid fa-bed" style="color:rgba(197, 197, 197, 0.884);"></i>
                <p> <ng-container *ngIf="dormitorios && dormitorios > 0 "> {{ dormitorios }} </ng-container> Quartos</p>
              </div>
            </div>
            <!-- 🔹 Dropdown de opções -->
            <div class="dropdown-options-principal" *ngIf="dropdownOpenDormitorios">
              <div class="counter">
                <button class="counter-btn" (click)="decrement('dormitorios')">−</button>
                <span class="counter-value">{{ dormitorios }}</span>
                <button class="counter-btn" (click)="increment('dormitorios')">+</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- <div class="select-campo-filtro" *ngIf="selectedFinalidade">
      <i class="fa-solid fa-bed" style="color:rgba(197, 197, 197, 0.884);"></i>
      <select [(ngModel)]="selectedQuartos" (change)="dormitoriosChange()">
        <option value=null>Dormitórios</option>
        <option *ngFor="let num of [1, 2, 3, 4, '5+']" [value]="num">{{ num }}</option>
      </select>
    </div> -->
    <div class="select-campo-filtro">
      <div class="select-filtro">
        <div style="border: none; background-color: transparent;">
          <div class="select-wrapper">
            <div class="autocomplete-input" (click)="toggleDropdownVagas($event)">
              <div class="scroll-container">
                <i class="fa-solid fa-car" style="color:rgba(197, 197, 197, 0.884);"></i>
                <p> <ng-container *ngIf="vagas && vagas >0 "> {{ vagas }} </ng-container>Vagas</p>
              </div>
            </div>
            <!-- 🔹 Dropdown de opções -->
            <div class="dropdown-options-principal" *ngIf="dropdownOpenVagas">
              <div class="counter">
                <button class="counter-btn" (click)="decrement('vagas')">−</button>
                <span class="counter-value">{{ vagas }}</span>
                <button class="counter-btn" (click)="increment('vagas')">+</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- <div class="select-campo-filtro" *ngIf="selectedFinalidade">
      <i class="fa-solid fa-car" style="color:rgba(197, 197, 197, 0.884);"></i>
      <select [(ngModel)]="selectedVagas" (change)="vagasChange()">
        <option value=null>Vagas</option>
        <option *ngFor="let num of [1, 2, 3, 4, '5+']" [value]="num">{{ num }}</option>
      </select>
    </div> -->

    <div class="select-campo-filtro">
      <div class="select-filtro">
        <div style="border: none; background-color: transparent;">
          <div class="select-wrapper">
            <div class="autocomplete-input" (click)="toggleDropdownMetros($event)">
              <div class="scroll-container">
                <i class="fa-solid fa-up-right-and-down-left-from-center" style="color:rgba(197, 197, 197, 0.884);"></i>
                <p>
                  <ng-container *ngIf="temArea">
                    {{ areaDe }} - {{areaAte}}
                  </ng-container>
                  Área
                </p>
              </div>
            </div>
            <!-- 🔹 Dropdown de opções -->
            <div class="dropdown-options-principal" *ngIf="dropdownOpenMetros">
              <div class="div-campo-filtro-adicional">
                <input class="select-campo-filtro-adicional" type="text" thousandSeparator="." [(ngModel)]="areaDe"
                  placeholder="De" />
                <input class="select-campo-filtro-adicional" type="text" thousandSeparator="." [(ngModel)]="areaAte"
                  placeholder="Até" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 
    <div class="select-campo-filtro" *ngIf="selectedFinalidade">
      <i class="fa-solid fa-up-right-and-down-left-from-center" style="color:rgba(197, 197, 197, 0.884);"></i>
      <select [(ngModel)]="selectedMetragem" (change)="atualizarMetragem()">
        <option [value]="null">Metragem</option>
        <option *ngFor="let num of opcoesMetragem" [value]="num.valor">
          {{ num.label }}
        </option>
      </select>
    </div> -->
    <div class="circle-icon-busca" (click)="buscarImoveisFiltro()">
      <i class="fa-solid fa-magnifying-glass" style="color: #fff; zoom:1.2;"></i>
    </div>
  </div>

  <div *ngIf="!hideOnProduciton">
    <button type="button" class="btn-filtro " (click)="toggleOverlay()" *ngIf="!mobile"
      style="border: 1px solid #ff0400!important; color: #ff0400; display: flex; justify-content: center; width: 150px;">
      <span *ngIf="!isOverlayOpen">Ver mapa</span>
      <span *ngIf="isOverlayOpen">Fechar mapa</span>
    </button>
  </div>

</div>

<div class="div-init-filtro row-reverse" *ngIf="!hideOnProduciton">
  <button type="button" class="btn-filtro" (click)="toggleOverlay()" *ngIf="!mobile" style="border: 1px solid #ff0400!important; color: #ff0400; display: flex; justify-content: center;   height: 50px;
  width: 150px;">
    <span *ngIf="!isOverlayOpen">Ver mapa</span>
    <span *ngIf="isOverlayOpen">Fechar mapa</span>
  </button>

  <!-- <select class="" (click)="toggleOverlay()" *ngIf="selectedFinalidade">
    <option value="option1">Selecione</option>
    <option value="option1">Opção 1</option>
    <option value="option2">Opção 2</option>
    <option value="option3">Opção 3</option>
  </select> -->
</div>
<div style="display: block; justify-content: center; width: 100%;">

  <div *ngIf="quantidade2 === 0"
    style="display: flex; justify-content: center; font-size: 40px; color:#858585; margin: 10vh auto;">
    Nenhum imóvel foi encontrado
  </div>
  <div class="body-lista">
    <div class="cards"
      [ngClass]="{'overlay-opened': gridState === 'overlay-opened','overlay-filter-open': gridState === 'filter-open'}">
      <div class="card-destaque" *ngFor="let imovel of imoveis2">
        <div class="header-card">
          <div class="div-img">
            <!-- <img [src]="imovel?.imagens[0]?.link_thumb" alt="Imagem" class="image-card"> -->
            <app-swiper-imagens [imovel]="imovel" [imagens]="imovel.imagens" [imovelSlug]="imovel.slug"></app-swiper-imagens>

          </div>
        </div>
        <div class="body-card" (click)="abreImovel(imovel?.slug)">
          <p class="tipo"><span><b>{{ imovel?.subtipo }}</b></span><span style="font-size: 13px;">{{ imovel?.codigo
              }}</span></p>
          <!-- endereco -->
          <p class="titulo">{{ imovel | enderecoImovel }}</p>


          <div
            style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; letter-spacing: -0.3px;">

            <div style="display: flex; flex-wrap: nowrap; justify-content: center; align-items: center;">
               <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <span *ngIf="hasFeirao(imovel) && (imovel?.valor_locacao_anterior ?? imovel?.valor_venda_anterior ?? 0 ) > 0"
                  class="valor-anterior">
                  De: <s>{{ (imovel?.valor_locacao_anterior ??
                    imovel?.valor_venda_anterior ) | currency: 'BRL'}}<span *ngIf="imovel?.valor_locacao_anterior != null">/mês</span></s>
                    </span>
                    <p class="valor" style="vertical-align: middle;">
                      <ng-container *ngIf="imovel?.valor_locacao != null || imovel?.valor_venda != null; else sobConsulta">
                      {{(imovel?.valor_locacao ?? imovel?.valor_venda) | currency: 'BRL'}}<span *ngIf="imovel?.valor_locacao != null" style="white-space: nowrap;">/mês</span>
                        </ng-container>
                        <ng-template #sobConsulta>
                          Sob Consulta
                          </ng-template>
                          </p>
                          </div>
            </div>
            <div class="div-icones-imovel">

              <p *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'"
                style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
                <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>


              </p>

              <p *ngIf="imovel.subtipo | deveExibirAtributo: 'terreno_total'"
                style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
                <b>{{ (imovel?.terreno_total ?? imovel?.area_privativa) | number:'1.0-0' }} {{imovel.medida}} </b>

                <br />
              </p>

              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
                *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                style="margin: 0px 5px 0 5px;">
                <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                  <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                  <b>{{ imovel?.dormitorios }}
                    <sup *ngIf="imovel?.suites && imovel.suites > 0" style="font-weight: 600; font-size: 0.75em;">{{
                      imovel.suites }}</sup>
                  </b>

                </p>
              </div>

              <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                  <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>
                  <b>{{ imovel?.banheiros ?? 0 }}</b>

                </p>
              </div>
              <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                  <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                  <b>{{ imovel?.garagens ?? 0 }}</b>
                </p>
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="overlay-filter" [ngClass]="{ 'overlay-filter-open': isOverlayFilterOpen }">
      <div class="div-titulo" [ngClass]="{'div-titulo-scrolled': !isScrolled}" [class.scrolled]="isScrolled">
        <!-- <p class="titulo-busca">Busca Imóveis</p> -->
        <a class="icone-busca" (click)="toggleFilterOverlay()">
          <i class="fa-solid fa-x fa-flip-both"></i>
        </a>
      </div>

      <div class="btn-group" role="group">
        <button type="button" class="btn" [class.active]="selectedFinalidade === 2"
          (click)="selectedFinalidade = 2">Comprar</button>
        <button type="button" class="btn" [class.active]="selectedFinalidade === 1"
          (click)="selectedFinalidade = 1">Alugar</button>
      </div>
      <div class="div-adicional-filtro" *ngIf="!isCodigo">
        <div class="select-campo-filtro">
          <div class="select-filtro">
            <div style="border: none; background-color: transparent;">
              <div class="select-wrapper">
                <div class="autocomplete-input" (click)="toggleDropdownBairro($event)">
                  <!-- <input class="autocomplete-input" type="text" [(ngModel)]="searchTextBairro"
                  placeholder="Digite para buscar..." (ngModelChange)="onSearchChange($event)"/> -->
                  <div class="scroll-container">
                    <span *ngIf="selectedBairrosNomes.length > 0; else placeholder">
                      {{ selectedBairrosNomes.join(', ') }}
                    </span>
                  </div>
                  <ng-template #placeholder>Busque por Bairro</ng-template>
                </div>

                <!-- 🔹 Dropdown de opções -->
                <div class="dropdown-options" *ngIf="dropdownOpenBairro">
                  <input type="text" [(ngModel)]="searchTextBairro" (input)="filterOptionsBairro()"
                    placeholder="Digite para filtrar..." class="autocomplete-input" />

                  <label *ngFor="let bairro of filteredBairros" class="option">
                    <input type="checkbox" class="option-checkbox" [value]="bairro.nome"
                      (change)="toggleSelectionBairro(bairro)" [checked]="selectedBairrosNomes.includes(bairro.nome)" />
                    <span class="custom-checkbox"></span>
                    {{ bairro.nome }}
                  </label>

                  <div class="no-results" *ngIf="filteredBairros.length === 0">
                    Nenhum bairro encontrado
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="div-adicional-filtro" *ngIf="isCodigo">
        <div class="select-campo-filtro">
          <div class="select-filtro">
            <div style="border: none; background-color: transparent;">
              <div class="autocomplete-input">
                <input matInput class="autocomplete-input" type="text" [(ngModel)]="searchCod"
                  (ngModelChange)="onSearchChange($event)" placeholder="Separar por virgulas se necessário"
                  [matAutocomplete]="auto" />

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  @for (tip of tips; track tip) {
                  <mat-option [value]="tip">{{tip}}</mat-option>
                  }
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-ckbx">
        <input type="checkbox" (change)="checkCod()" [checked]="isCodigo">
        <p>Buscar por código ou palavra-chave</p>
      </div>

      <div class="form-container">
        <div class="form-group full-width">
          <div class="form-group-icon">
            <i class="fa-sharp fa-solid fa-house"></i>
          </div>
          <div class="mat-select-custom" style="width: 100% !important;">
            <div class="select-wrapper">
              <!-- 🔹 Campo de entrada e exibição -->
              <div class="autocomplete-input " (click)="toggleDropdownTip($event)">
                <div class="scroll-container" style="padding: 5px 0;">
                  <span *ngIf="selectedTiposNomes.length > 0; else placeholder">
                    {{ selectedTiposNomes.join(', ') }}
                  </span>
                </div>
                <ng-template #placeholder>Busque por categoria</ng-template>
              </div>

              <!-- 🔹 Dropdown de opções -->
              <div class="dropdown-options" *ngIf="dropdownOpenTip">
                <label *ngFor="let subtipo of subTipos;let i = index;" class="option">
                  <input type="checkbox" class="option-checkbox" (change)="toggleSelectionTip(i)"
                    [checked]="subtipo.checked" />
                  <span class="custom-checkbox"></span>

                  {{ subtipo.name }}
                </label>

                <div class="no-results" *ngIf="subTipos.length === 0">
                  Nenhuma categoria encontrada
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="filter-group" style="margin-top: 10px;">
        <div class="filter-item">
          <i class="fa-solid fa-bed"></i>
          <span class="filter-label">Quartos</span>
          <div class="counter">
            <button class="counter-btn" (click)="decrement('dormitorios')">−</button>
            <span class="counter-value">{{ dormitorios }}</span>
            <button class="counter-btn" (click)="increment('dormitorios')">+</button>
          </div>
        </div>

        <!-- <div class="filter-item">
          <i class="fa-solid fa-bed"></i>
          <span class="filter-label">Suítes</span>
          <div class="counter">
            <button class="counter-btn" (click)="decrement('suites')">−</button>
            <span class="counter-value">{{ suites }}</span>
            <button class="counter-btn" (click)="increment('suites')">+</button>
          </div>
        </div> -->

        <div class="filter-item">
          <i class="fa-solid fa-shower"></i>
          <span class="filter-label">Banheiros</span>
          <div class="counter">
            <button class="counter-btn" (click)="decrement('banheiros')">−</button>
            <span class="counter-value">{{ banheiros }}</span>
            <button class="counter-btn" (click)="increment('banheiros')">+</button>
          </div>
        </div>

        <div class="filter-item">
          <i class="fa-solid fa-car"></i>
          <span class="filter-label">Vagas</span>
          <div class="counter">
            <button class="counter-btn" (click)="decrement('vagas')">−</button>
            <span class="counter-value">{{ vagas }}</span>
            <button class="counter-btn" (click)="increment('vagas')">+</button>
          </div>
        </div>
      </div>

      <div class="title-filtro" style="margin-top: 10px;">
        <i class="fa-solid fa-money-bill" style="margin: 10px;"></i>
        <p>Faixa de preço</p>
      </div>
      <div class="div-campo-filtro">
        <input class="select-campo-filtro" type="text" mask="separator.2" prefix="R$ " thousandSeparator="."
          decimalMarker="," style="width: 100%!important;margin: 5px 10px!important; padding: 12px 20px!important;"
          [(ngModel)]="valorMinimo" placeholder="De" />
        <input class="select-campo-filtro" type="text" mask="separator.2" prefix="R$ " thousandSeparator="."
          decimalMarker="," style="width: 100%!important;margin: 5px 10px!important; padding: 12px 20px!important;"
          [(ngModel)]="valorMaximo" placeholder="Até" />
      </div>

      <div class="title-filtro">
        <i class="fa-solid fa-up-right-and-down-left-from-center" style="margin: 10px;"></i>
        <p>Metragem</p>
      </div>
      <div class="div-campo-filtro">
        <input type="number" class="select-campo-filtro"
          style="width: 100%!important;margin: 5px 10px!important; padding: 12px 20px!important;" [(ngModel)]="areaDe"
          placeholder="De" />
        <input type="number" class="select-campo-filtro"
          style="width: 100%!important;margin: 5px 10px!important; padding: 12px 20px!important;" [(ngModel)]="areaAte"
          placeholder="Até" />
      </div>

      <!-- Financiamento -->
      <div class="title-filtro">
        <i class="fa-solid fa-money-bill" style="margin: 10px;"></i>
        <p>Financiamento</p>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn" [class.active]="selectedFinanciamento === true"
          (click)="selectedFinanciamento = true">Sim</button>

        <button type="button" class="btn" [class.active]="selectedFinanciamento === false"
          (click)="selectedFinanciamento = false">Não</button>
      </div>

      <!-- Financiamento -->
      <div class="title-filtro">
        <i class="fa-solid fa-couch" style="margin: 10px;"></i>
        <p>Mobiliado</p>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn" [class.active]="selectedMobiliado === true"
          (click)="selectedMobiliado = true">Sim</button>

        <button type="button" class="btn" [class.active]="selectedMobiliado === false"
          (click)="selectedMobiliado = false">Não</button>
      </div>

      <!-- <div class="form-container">
        <div class="form-group full-width">
          <div class="form-group-icon">
            <i class="fa-sharp fa-solid fa-house"></i>
          </div>
          <div class="form-group-content">
            <label>Características do Imóvel</label>
            <div class="checkbox-group">
              <label *ngFor="let carac of infraestruturaExtras" class="checkbox-label">
                <input 
                  type="checkbox" 
                  [checked]="carac.selected"
                  (change)="toggleSelectionCarac(carac)">
                {{ carac.label }}
              </label>
            </div>
          </div>
        </div>
      </div> -->


      <div class="title-filtro">
        <i class="fa-solid fa-house-fire" style="margin: 10px;"></i>
        <p>Caracteristicas</p>
      </div>
      <div class="div-adicional-filtro">
        <div class="select-campo-filtro">
          <div class="select-filtro">
            <div style="border: none; background-color: transparent;">
              <div class="select-wrapper">
                <!-- Campo de seleção -->
                <div class="autocomplete-input" (click)="toggleDropdownCaracteristicas($event)">
                  <div class="scroll-container">
                    <span *ngIf="selectedCaracteristicas.length > 0; else placeholderCar">
                      {{ selectedCaracteristicas.join(', ') }}
                    </span>
                  </div>
                  <ng-template #placeholderCar>+ Caracteristicas</ng-template>
                </div>

                <!-- 🔹 Dropdown de opções -->
                <div class="dropdown-options" *ngIf="dropdownCaracteristicas">
                  <!-- Campo de pesquisa -->
                  <input type="text" [(ngModel)]="searchTextCarac" placeholder="Digite para filtrar..."
                    class="autocomplete-input" />

                  <!-- Lista de checkboxes -->
                  <label *ngFor="let carac of filteredCaracteristicas();" class="option">
                    <input type="checkbox" (change)="toggleSelectionCarac(carac.name)" [checked]="carac.checked" />
                    {{ carac.name }}
                  </label>

                  <!-- Mensagem quando não houver resultados -->
                  <div class="no-results" *ngIf="filteredCaracteristicas().length === 0">
                    Nenhuma característica encontrada
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="div-adicional-filtro" style="margin-top: 10px;">
        <div class="select-campo-filtro">
          <div class="select-filtro">
            <i class="fa-sharp fa-solid fa-location-dot" style="color:rgba(197, 197, 197, 0.884);"></i>
            <select [(ngModel)]="selectedListaTag" style="width:95%!important; color: #666666!important;">
              <option value=''>Tags</option>
              <option *ngFor="let tag of tags" [value]="tag.value">
                {{ tag.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 9vh; height: 18vh; display: block;"></div>

      <div class="btn-space" [ngClass]="{ 'btn-space-open': isOverlayFilterOpen }">
        <button mat-button class="btn-busca-limpar" (click)="limparFiltros()">Limpar filtros</button>
        <button mat-button class="btn-busca" (click)="buscarImoveisFiltro(true)">Filtrar pesquisa</button>
      </div>
    </div>

  </div>


  <div style="display: flex; justify-content: space-around; margin: 35px 0;">

    <div class="paginacao" *ngIf="quantidade2 > 0">
      <button (click)="previousPage()" class="pag-button" [disabled]="buscaResponse?.page === 1"
        style="margin-right: 40px;">
        <svg style="display: flex; margin-left: -3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30"
          height="25" [ngStyle]="{'fill': getSvgColor(), 'stroke': getSvgColor()}" stroke-width="2" class="size-1"
          transform="scale(-1, 1)">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </button>

      <div *ngFor="let page of getPages()" style="margin: 0; width: 50px; font-weight: 600; font-size: 20px;">
        <button class="pag-button" style="box-shadow: none!important;" mat-button
          [disabled]="buscaResponse?.page == page" (click)="navigateToPage(page)">
          {{ page }}
        </button>
      </div>

      <button (click)="nextPage()" class="pag-button" [disabled]="buscaResponse?.page === buscaResponse?.totalPages"
        style="margin-left: 40px;">
        <svg style="display: flex; margin-left: 3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30"
          height="26" [ngStyle]="{'fill': getSvgColorEnd(), 'stroke': getSvgColorEnd()}" stroke-width="2"
          class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>


  <!-- <div class="overlay" [ngClass]="{ 'overlay-open': isOverlayOpen }">
      <div class="map" id=>
        <iframe
        width="100%"
        height="100%"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
      </div> -->

  <div class="overlay" [ngClass]="{ 'overlay-open': isOverlayOpen }">
    <div class="maps" id="map"></div>
  </div>
</div>
<div id="info-div" *ngIf="this.isOverlayOpen">
  <!-- O conteúdo será preenchido dinamicamente -->
</div>

<app-loader [isLoading]="isLoading">

</app-loader>